export const SceneStatus = Object.freeze({
  GENERATING: 'GENERATING',
  GENERATED: 'GENERATED',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REGENERATING: 'REGENERATING',
  MANUAL_IMAGE: 'MANUAL_IMAGE',
  FAILED: 'FAILED'
});

export const BLOCKING_STATUSES = Object.freeze([
  SceneStatus.WAITING_APPROVAL,
  SceneStatus.REJECTED,
  SceneStatus.FAILED,
  SceneStatus.GENERATING,
  SceneStatus.REGENERATING
]);

export const REVIEW_TABS = Object.freeze([
  { key: 'images', label: 'Imagens', enabled: true },
  { key: 'narration', label: 'Narração', enabled: false },
  { key: 'music', label: 'Música', enabled: false },
  { key: 'thumbnail', label: 'Thumbnail', enabled: false },
  { key: 'captions', label: 'Legendas', enabled: false },
  { key: 'metadata', label: 'Metadados', enabled: false }
]);

export function getStatusLabel(status) {
  const key = String(status || '').toUpperCase();
  switch (key) {
    case SceneStatus.GENERATING: return 'Gerando';
    case SceneStatus.GENERATED: return 'Gerado';
    case SceneStatus.WAITING_APPROVAL: return 'Aguardando Aprovação';
    case SceneStatus.APPROVED: return 'Aprovado';
    case SceneStatus.REJECTED: return 'Reprovado';
    case SceneStatus.REGENERATING: return 'Regenerando';
    case SceneStatus.MANUAL_IMAGE: return 'Imagem Manual';
    case SceneStatus.FAILED: return 'Falhou';
    default: return 'Pendente';
  }
}

export function getStatusColor(status) {
  const key = String(status || '').toUpperCase();
  switch (key) {
    case SceneStatus.APPROVED:
    case SceneStatus.MANUAL_IMAGE:
      return 'success';
    case SceneStatus.REJECTED:
    case SceneStatus.FAILED:
      return 'error';
    case SceneStatus.GENERATING:
    case SceneStatus.REGENERATING:
      return 'info';
    case SceneStatus.WAITING_APPROVAL:
    case SceneStatus.GENERATED:
      return 'warning';
    default:
      return 'default';
  }
}
